import Backend from 'App/Dataman-Backend';

const { apiUrlContacts, apiUrlContactsStats, apiUrlCustomerAddresses, apiUrlMediaResourceTypes, apiUrlSuffix } =
  Backend.config;

export const CONTACTS_PATHS = {
  contacts: apiUrlContacts,
  stats: apiUrlContactsStats,
  customerAddresses: apiUrlCustomerAddresses,
  mediaResourceTypes: apiUrlMediaResourceTypes,
  suffix: apiUrlSuffix,
};
